import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatDialogModule } from '@angular/material/dialog';

import { ChipModule } from '@libs/src/chip/chip.module';
import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';

import { AddToCalendarDialogService } from '@libs/src/add-to-calendar-dialog/add-to-calendar-dialog.service';

import { AddToCalendarChipsComponent } from './add-to-calendar-chips/add-to-calendar-chips.component';
import { AddToCalendarDialogComponent } from './add-to-calendar-dialog.component';

@NgModule({
  declarations: [AddToCalendarDialogComponent, AddToCalendarChipsComponent],
  exports: [AddToCalendarChipsComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    ChipModule,
    TtcButtonSharedModule,
    MatDialogModule,
  ],
  providers: [AddToCalendarDialogService],
})
export class AddToCalendarDialogModule {}
